import mealsStore from '../../store/mealsStore';
import MealActionsPopup from '../MealActionsPopup/MealActionsPopup';
import integrationsStore from 'src/mobx/integrationStore';
import { modalStore } from 'src/mobx/modalStore';
import { IProductV4Size } from 'src/types/product';
import { getTranslate } from 'src/utils/helpers';
import './style.scss';

interface IProps {
  size: IProductV4Size;
}

const MealSize: React.FC<IProps> = (props: IProps): JSX.Element => {
  const renameSize = () => {
    if (!props.size.id) return;

    modalStore.openMealSizeEditModal({
      id: props.size.id,
      name: props.size.name,
      onSubmit: mealsStore.renameSize,
      onDelete: mealsStore.deleteSize,
    });
  };

  const deleteSize = () => {
    mealsStore.deleteSize(props.size.id);
  };

  return (
    <li className="meal-size mr-2" id={String(props.size.id) + '-meal-size'}>
      <div className="d-flex flex-row full-width justify-content-center align-items-center">
        <p className="family-regular text-size-18 color-dark letter-spacing-12 text-uppercase text-elipsis">{getTranslate(props.size.name)}</p>
        <MealActionsPopup
          restrictionPosEdit={integrationsStore.posRestrictions?.comboMealEditSizeName}
          restrictionPosDelete={integrationsStore.posRestrictions?.comboMealSizeDelete}
          openEditModal={renameSize}
          handleDelete={deleteSize}
        />
      </div>
    </li>
  );
};

export default MealSize;
